// Declare the environment variables that Vite will provide
declare global {
	interface ImportMetaEnv {
		readonly VITE_HAPPYDOC_API_SERVER_URL: string;
		readonly VITE_HAPPYDOC_TRANSCRIBE_SERVER_URL: string;
		readonly VITE_HAPPYDOC_INSIGHTS_SERVER_URL: string;
		readonly VITE_PUBLIC_ENV: string;
		readonly VITE_PUBLIC_SUPABASE_URL: string;
		readonly VITE_PUBLIC_SUPABASE_ANON_KEY: string;
		readonly VITE_PENDO_API_KEY: string;
		readonly VITE_MUI_PRO_KEY: string;
	}
}

const env = import.meta.env;

export const {
	VITE_HAPPYDOC_API_SERVER_URL,
	VITE_HAPPYDOC_TRANSCRIBE_SERVER_URL,
	VITE_HAPPYDOC_INSIGHTS_SERVER_URL,
	VITE_PUBLIC_ENV,
	VITE_PUBLIC_SUPABASE_URL,
	VITE_PUBLIC_SUPABASE_ANON_KEY,
	VITE_PENDO_API_KEY,
	VITE_MUI_PRO_KEY,
	VITE_SENTRY_DSN,
} = env;

export default env;